import { render, staticRenderFns } from "./TaxiMapStateSummary.vue?vue&type=template&id=1883015d&scoped=true&"
import script from "./TaxiMapStateSummary.vue?vue&type=script&lang=js&"
export * from "./TaxiMapStateSummary.vue?vue&type=script&lang=js&"
import style0 from "./TaxiMapStateSummary.vue?vue&type=style&index=0&id=1883015d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1883015d",
  null
  
)

export default component.exports